import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import api from '../../api';
import ErrorPage from './ErrorPage';

export type MaintenanceMessageType = {
  studioGroup: StudioGroup;
  title: string;
  message: string;
  isActive: boolean;
};

export default function Maintenance() {
  const [maintenanceMessage, setMaintenanceMessage] = useState<MaintenanceMessageType | null>(null);
  const { t } = useTranslation();
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  useEffect(() => {
    const getCustomMaintenance = async () => {
      const response = await api.get<MaintenanceMessageType>(
        `/studio-groups/${REACT_APP_P_STUDIO_GROUP}/maintenance-message`,
      );
      const maintenanceMessage = response.data;
      if (!maintenanceMessage?.isActive) return;
      setMaintenanceMessage(maintenanceMessage);
    };
    getCustomMaintenance();
  }, [REACT_APP_P_STUDIO_GROUP]);

  return (
    <ErrorPage
      headerText={maintenanceMessage?.title || t(`ERRORS.MAINTENANCE.TITLE`)}
      message={
        maintenanceMessage ? (
          <span dangerouslySetInnerHTML={{ __html: maintenanceMessage.message }} />
        ) : (
          <Trans i18nKey="ERRORS.MAINTENANCE.MESSAGE" />
        )
      }
    />
  );
}
